import {
  CloseIcon as CloseDefault,
  Label as LabelDefault,
  Typography
} from "@packages/ds";
import styled from "styled-components";

import * as Dropdown from "ds/Dropdown";

export const TriggerStyled = styled(Dropdown.Trigger)`
  margin-right: 12px;
  &:hover {
    color: var(
      --backups-calculator-button-color,
      var(--button-slate-color, var(--slate))
    );
    background-color: var(
      --backups-calculator-button-background-color,
      var(--button-color-neutral-300-background-color, var(--color-neutral-300))
    );
  }
`;

export const DropdownContent = styled(Dropdown.Content)`
  padding: 0px;
  width: 320px;
  right: 0px;
  position: relative;
`;

export const DropdownInfoTop = styled.div`
  padding: 16px;
  & > ${Typography.Title} {
    font-size: 14px;
    line-height: normal;
    margin-bottom: 6px;
  }
`;

export const Description = styled.div`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--section-ebony-light-color, var(--ebony-light));
`;

export const DropdownRow = styled.div`
  display: flex;
  align-items: center;
`;

export const FirstRow = styled(DropdownRow)`
  justify-content: space-between;
  margin-bottom: 28px;
`;

export const Close = styled(CloseDefault)`
  margin-left: auto;
  margin-right: 17px;
  width: 20px;
  height: 20px;
`;

export const Label = styled(LabelDefault)`
  margin-bottom: 0;
  & > label {
    color: var(--section-granite-color, var(--granite));
  }
`;

export const NumberLabel = styled(LabelDefault)`
  margin-bottom: 0;
  & > label {
    color: var(--section-ebony-light-color, var(--ebony-light));
  }
  &.discount {
    text-decoration: line-through;
  }
`;

export const DropdownInfoBottom = styled.div`
  height: 48px;

  background-color: var(
    --section-color-primary-100-background-color,
    var(--color-primary-100)
  );
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px 0 16px;

  & > ${NumberLabel} {
    margin-bottom: 0;
    & > label {
      color: var(--section-ebony-light-color, var(--ebony-light));
    }
  }
`;
